exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-status[data-v-2f49a7d6] {\n    font-size: 24px;\n    cursor: pointer;\n}\n.contact-list[data-v-2f49a7d6] {\n    font-size: 12px;\n    line-height: 24px;\n    margin-right: 10px;\n    font-weight: bold;\n    white-space: nowrap;\n    border-radius: 5px;\n    padding: 0px 8px;\n    margin-bottom: 4px;\n}\n.contact-list i[data-v-2f49a7d6]{\n    font-size: 14px;\n    border-radius: 3px;\n    margin-right: 4px;\n}\n", ""]);

// exports
